import gql from "graphql-tag";

export const EDIT_WOOD_INFO_MUTATION = gql`
  mutation EditWoodInfoMutation($reportId: ID!, $sheetId: ID!, $woodInfo: WoodInfoInput!) {
    editReportSheetWoodInfo(reportId: $reportId, sheetId: $sheetId, woodInfo: $woodInfo)
  }
`;
